import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: 'transparent',
  },
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    marginRight: 40,
    fontWeight: 500,
    fontSize: 14,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
    padding: 0,
  },
  tabsPaper: {
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
  },
  tabsPanel: {
    width: '100%',
  },
  tabBox: {
    margin: theme.spacing(3.5, 0, 0),

    '& > div > div': {
      padding: 0,
    },
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
}));
